import { useLayoutEffect, useRef } from "react";

export function useCSSProperty(name: string, value: string, dependencies: Array<unknown>) {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    const element = ref.current;
    element.style.setProperty(name, value);

    return () => {
      element.style.removeProperty(name);
    };
  }, dependencies);

  return ref;
}
